var render = function render(){var _vm=this,_c=_vm._self._c;return _c('google-pay-button',{staticStyle:{"width":"100%"},attrs:{"environment":_vm.gPayEnvironment,"button-type":_vm.buttonType,"button-color":_vm.buttonColor,"existing-payment-method-required":_vm.existingPaymentMethodRequired,"error":_vm.onError},domProps:{"paymentRequest":{
    apiVersion: _vm.paymentRequest.apiVersion,
    apiVersionMinor: _vm.paymentRequest.apiVersionMinor,
    allowedPaymentMethods: _vm.paymentRequest.allowedPaymentMethods,
    merchantInfo: _vm.paymentRequest.merchantInfo,
    transactionInfo: {
      totalPriceStatus: 'FINAL',
      totalPriceLabel: 'Total',
      totalPrice: _vm.formData.purchaseAmount.toString(),
      currencyCode: _vm.formData.country === 'UK' ? 'GBP' : 'EUR',
      countryCode: _vm.formData.country === 'UK' ? 'GB' : 'IE'
    },
    callbackIntents: ['PAYMENT_AUTHORIZATION']
  },"onPaymentAuthorized":_vm.onPaymentDataAuthorized},on:{"loadpaymentdata":_vm.onLoadPaymentData,"click":_vm.onOpen,"cancel":_vm.onCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }